import { _ as t } from "main/modulepreload-polyfill";
function l({ query: e }) {
  const i = window.matchMedia(e);
  return new Promise(function (r) {
    i.matches ? r(!0) : i.addEventListener("change", r, { once: !0 });
  });
}
function c({ element: e }) {
  return new Promise(function (i) {
    const r = new window.IntersectionObserver(async function (o) {
      for (const n of o)
        if (n.isIntersecting) {
          r.disconnect(), i(!0);
          break;
        }
    });
    r.observe(e);
  });
}
function p() {
  return new Promise(function (e) {
    "requestIdleCallback" in window
      ? window.requestIdleCallback(e)
      : setTimeout(e, 200);
  });
}
const E = Object.assign({
  "/frontend/islands/cart-agreement.js": () =>
    t(() => import("components/cart-agreement"), [], import.meta.url),
  "/frontend/islands/cart-items.js": () =>
    t(() => import("components/cart-items"), [], import.meta.url),
  "/frontend/islands/cart-note.js": () =>
    t(() => import("components/cart-note"), [], import.meta.url),
  "/frontend/islands/cart-notification.js": () =>
    t(() => import("components/cart-notification"), [], import.meta.url),
  "/frontend/islands/cart-remove-button.js": () =>
    t(() => import("components/cart-remove-button"), [], import.meta.url),
  "/frontend/islands/collection-drawer.js": () =>
    t(() => import("components/collection-drawer"), [], import.meta.url),
  "/frontend/islands/collection-slider-component.js": () =>
    t(
      () => import("components/collection-slider-component"),
      [],
      import.meta.url
    ),
  "/frontend/islands/collection-sort.js": () =>
    t(() => import("components/collection-sort"), [], import.meta.url),
  "/frontend/islands/disclosure-form.js": () =>
    t(() => import("components/disclosure-form"), [], import.meta.url),
  "/frontend/islands/disclosure-item.js": () =>
    t(() => import("components/disclosure-item"), [], import.meta.url),
  "/frontend/islands/disclosure-menu.js": () =>
    t(() => import("components/disclosure-menu"), [], import.meta.url),
  "/frontend/islands/filter-button.js": () =>
    t(() => import("components/filter-button"), [], import.meta.url),
  "/frontend/islands/filter-remove.js": () =>
    t(() => import("components/filter-remove"), [], import.meta.url),
  "/frontend/islands/gift-card-recipient.js": () =>
    t(() => import("components/gift-card-recipient"), [], import.meta.url),
  "/frontend/islands/header-section.js": () =>
    t(() => import("components/header-section"), [], import.meta.url),
  "/frontend/islands/header-top-section.js": () =>
    t(() => import("components/header-top-section"), [], import.meta.url),
  "/frontend/islands/looks-item.js": () =>
    t(() => import("components/looks-item"), [], import.meta.url),
  "/frontend/islands/map-object.js": () =>
    t(() => import("components/map-object"), [], import.meta.url),
  "/frontend/islands/media-slideshow.js": () =>
    t(() => import("components/media-slideshow"), [], import.meta.url),
  "/frontend/islands/modal-predictive-search.js": () =>
    t(() => import("components/modal-predictive-search"), [], import.meta.url),
  "/frontend/islands/password-modal.js": () =>
    t(() => import("components/password-modal"), [], import.meta.url),
  "/frontend/islands/pickup-availability-drawer.js": () =>
    t(
      () => import("components/pickup-availability-drawer"),
      [],
      import.meta.url
    ),
  "/frontend/islands/pickup-availability.js": () =>
    t(() => import("components/pickup-availability"), [], import.meta.url),
  "/frontend/islands/popup-modal.js": () =>
    t(() => import("components/popup-modal"), [], import.meta.url),
  "/frontend/islands/predictive-search.js": () =>
    t(() => import("components/predictive-search"), [], import.meta.url),
  "/frontend/islands/product-card.js": () =>
    t(() => import("components/product-card"), [], import.meta.url),
  "/frontend/islands/product-details-modal.js": () =>
    t(() => import("components/product-details-modal"), [], import.meta.url),
  "/frontend/islands/product-form.js": () =>
    t(() => import("components/product-form"), [], import.meta.url),
  "/frontend/islands/product-model.js": () =>
    t(() => import("components/product-model"), [], import.meta.url),
  "/frontend/islands/product-recommendations.js": () =>
    t(() => import("components/product-recommendations"), [], import.meta.url),
  "/frontend/islands/promo-section.js": () =>
    t(() => import("components/promo-section"), [], import.meta.url),
  "/frontend/islands/quantity-select.js": () =>
    t(() => import("components/quantity-select"), [], import.meta.url),
  "/frontend/islands/slideshow-component.js": () =>
    t(() => import("components/slideshow-component"), [], import.meta.url),
  "/frontend/islands/swatch-radios.js": () =>
    t(() => import("components/swatch-radios"), [], import.meta.url),
  "/frontend/islands/testimonials-component.js": () =>
    t(() => import("components/testimonials-component"), [], import.meta.url),
  "/frontend/islands/variant-radios.js": () =>
    t(() => import("components/variant-radios"), [], import.meta.url),
  "/frontend/islands/variant-selects.js": () =>
    t(() => import("components/variant-selects"), [], import.meta.url),
  "/frontend/islands/video-background-object.js": () =>
    t(() => import("components/video-background-object"), [], import.meta.url),
  "/frontend/islands/video-background.js": () =>
    t(() => import("components/video-background"), [], import.meta.url),
  "/frontend/islands/video-object.js": () =>
    t(() => import("components/video-object"), [], import.meta.url),
});
function f(e) {
  const i = new window.MutationObserver((o) => {
    for (let n = 0; n < o.length; n++) {
      const { addedNodes: d } = o[n];
      for (let _ = 0; _ < d.length; _++) {
        const s = d[_];
        s.nodeType === 1 && r(s);
      }
    }
  });
  async function r(o) {
    const n = o.tagName.toLowerCase(),
      d = `/frontend/islands/${n}.js`;
    if (/-/.test(n) && e[d]) {
      o.hasAttribute("client:visible") && (await c({ element: o }));
      const a = o.getAttribute("client:media");
      a && (await l({ query: a })),
        o.hasAttribute("client:idle") && (await p()),
        e[d]();
    }
    let s = o.firstElementChild;
    for (; s; ) r(s), (s = s.nextElementSibling);
  }
  r(document.body), i.observe(document.body, { childList: !0, subtree: !0 });
}
f(E);
theme.userInteraction = !1;
const m = ["mouseover", "keydown", "scroll", "touchstart"];
document.addEventListener("DOMContentLoaded", () => {
  m.forEach((e) => {
    document.addEventListener(e, u, { passive: !0 });
  });
});
function u() {
  (theme.userInteraction = !0),
    m.forEach((e) => {
      document.removeEventListener(e, u, { passive: !0 });
    });
}
theme.isTouchDevice = () =>
  "ontouchstart" in window ||
  navigator.maxTouchPoints > 0 ||
  navigator.msMaxTouchPoints > 0;
theme.debounce = (e, i) => {
  let r;
  return (...o) => {
    clearTimeout(r), (r = setTimeout(() => e.apply(void 0, o), i));
  };
};
theme.fetchConfig = (e = "json") => ({
  method: "POST",
  headers: { "Content-Type": "application/json", Accept: `application/${e}` },
});
theme.pauseAllMedia = () => {
  document.querySelectorAll(".js-youtube").forEach((e) => {
    e.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "*"
    );
  }),
    document.querySelectorAll(".js-vimeo").forEach((e) => {
      e.contentWindow.postMessage('{"method":"pause"}', "*");
    }),
    document.querySelectorAll("video").forEach((e) => e.pause()),
    document.querySelectorAll("product-model").forEach((e) => {
      e.modelViewerUI && e.modelViewerUI.pause();
    });
};
